<script lang="ts">
    let {
        active = false,
        color = "dark",
        height = 24,
        hoverColor = "#D25344",
        hoverEnabled = true,
        growReverse = false,
        reverseArrow = false,
        growFromRight = false,
        shiftRight = false,
    } = $props()

    const baseColor = color === "dark" ? "#242220" : "#fff"

    const longPathForward =
        "M40.869 5.68954L39.8084 6.75019L44.3083 11.25H1.99997V12.7501H44.3081L39.8084 17.2498L40.869 18.3104L47.1796 12L40.869 5.68954Z"

    const shortPathForward =
        "M17.8691 5.68954L16.8084 6.75019L21.3083 11.25H0V12.7501H21.3082L16.8084 17.2498L17.8691 18.3104L24.1796 12L17.8691 5.68954Z"

    const longPathReverse =
        "M24.1796 5.68954L23.119 6.75019L27.6188 11.25H0V12.7501H27.6188L23.119 17.2498L24.1796 18.3104L30.49 12L24.1796 5.68954Z"

    const shortPathReverse =
        "M12.1796 5.68954L11.119 6.75019L15.6188 11.25H0V12.7501H15.6188L11.119 17.2498L12.1796 18.3104L18.49 12L12.1796 5.68954Z"

    const shortPathRightAnchored =
        "M32.1309 5.68954L33.1916 6.75019L28.6917 11.25H50V12.7501H28.6918L33.1916 17.2498L32.1309 18.3104L25.8204 12L32.1309 5.68954Z"

    const longPathRightAnchored =
        "M9.13097 5.68954L10.1916 6.75019L5.69166 11.25H48V12.7501H5.69166L10.1916 17.2498L9.13097 18.3104L2.82034 12L9.13097 5.68954Z"

    // Choose which path to use based on props
    let currentPath = $derived(
        // Otherwise, fall back to the old logic
        growFromRight
            ? active
                ? longPathRightAnchored
                : shortPathRightAnchored
            : growReverse
              ? active
                  ? longPathReverse
                  : shortPathReverse
              : active
                ? longPathForward
                : shortPathForward
    )

    let currentColor = $derived(active && hoverEnabled ? hoverColor : baseColor)

    let width = $derived((50 / 24) * height)
</script>

<div class="svg-wrapper">
    <svg
        xmlns="http://www.w3.org/2000/svg"
        {width}
        {height}
        viewBox="0 0 50 24"
        fill="none"
        style="transition: all 0.3s ease;"
        role="img"
        aria-label="Arrow icon"
        class:reverse={reverseArrow}
        class:growFromRight
        class:active
        class:shiftRight
    >
        <path d={currentPath} fill={currentColor} style="transition: d 0.3s ease, fill 0.3s ease;"></path>
    </svg>
</div>

<style>
    .svg-wrapper {
        width: 50px;
        display: flex;
        justify-content: flex-start;
        svg {
            overflow: visible;
            cursor: pointer;
            &.reverse {
                transition: transform 0.3s ease;
                transform: rotate(180deg) translateX(50%);
            }
            &.reverse.active {
                transform: rotate(180deg) translateX(0%);
            }

            &.shiftRight {
                transform: translateX(50%);
            }
            &.shiftRight.active {
                transform: translateX(0%);
            }
        }

        path {
            transition:
                d 0.3s ease,
                fill 0.3s ease;
        }
    }
</style>
